import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { PORTRAIT_URL, scrollToId } from "@/lib/site";

function Portrait() {
  if (PORTRAIT_URL) {
    return <img src={PORTRAIT_URL} alt="Firaol Amsalu Dessalegn (FAD)" className="h-full w-full object-cover object-top" loading="lazy" data-testid="about-portrait" />;
  }
  return (
    <div className="h-full w-full bg-[#0B1F3A] relative grain grid place-items-center" data-testid="about-monogram">
      <div className="absolute inset-6 rounded-[22px] border border-white/10" />
      <div className="text-center">
        <span className="font-display text-7xl font-bold tracking-[0.2em] text-white">FAD</span>
        <p className="mt-4 text-xs tracking-[0.3em] uppercase text-[#C7A76C]">Firaol Amsalu Dessalegn</p>
      </div>
    </div>
  );
}

export function About() {
  return (
    <section id="about" className="py-24 sm:py-32 px-6 sm:px-10" data-testid="about-section">
      <div className="max-w-6xl mx-auto grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <Reveal className="lg:col-span-5">
          <div className="aspect-[4/5] rounded-[32px] overflow-hidden shadow-[0_30px_80px_-30px_rgba(11,31,58,0.45)]">
            <Portrait />
          </div>
        </Reveal>
        <Reveal className="lg:col-span-7" delay={0.1}>
          <p className="eyebrow">About FAD</p>
          <h2 className="font-display mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0B1F3A] leading-tight" data-testid="about-headline">
            A clearer perspective on Dubai real estate.
          </h2>
          <div className="mt-8 space-y-5 text-[17px] leading-relaxed text-[#172033]/85 max-w-xl">
            <p>
              I’m Firaol Amsalu Dessalegn, known as FAD. My focus is helping people understand Dubai real estate through clear information, practical comparisons, and conversations built around their goals.
            </p>
            <p className="text-[#697386]">
              My approach is simple: understand the person first, explain the options clearly, and help them ask better questions before making an important property decision.
            </p>
          </div>
          <button onClick={() => scrollToId("booking")} className="btn-primary mt-10" data-testid="about-book-briefing-button">
            Book a Briefing <ArrowRight size={16} />
          </button>
        </Reveal>
      </div>
    </section>
  );
}
